var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 50C71.0457 50 80 41.0457 80 30C80 18.9543 71.0457 10 60 10C48.9543 10 40 18.9543 40 30C40 41.0457 48.9543 50 60 50Z",
    fill: "#994D69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100 87.5C100 99.9265 100 110 60 110C20 110 20 99.9265 20 87.5C20 75.0735 37.9086 65 60 65C82.0915 65 100 75.0735 100 87.5Z",
    fill: "#994D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.98d093ca4a1851ffe0607ec19dc403ee.svg";
export { ForwardRef as ReactComponent };